import { useGetProxied } from '~/backend/connector-api/connector-components';
import { Features } from '~/components/FeatureToggle';
import AppConfig from '~/utils/appconfig';

/**
 * Eagerly fetches AI model lists and configurations for all
 * enabled workflows so they are already in the React Query
 * cache when the user opens the AI Assistant dialog.
 *
 * Must be called from a component that mounts when session
 * data becomes available (e.g. ConnectorWorkflows).
 */
export default function useConnectorModelPrefetch() {
    const contourEnabled = AppConfig.isFeatureEnabled(
        Features.CONTOUR_WORKFLOW
    );
    const doseEnabled = AppConfig.isFeatureEnabled(Features.DOSE_WORKFLOW);
    const imageEnabled = AppConfig.isFeatureEnabled(
        Features.IMAGE_TRANSLATION_WORKFLOW
    );
    const adaptEnabled = AppConfig.isFeatureEnabled(Features.ADAPT_WORKFLOW);

    // Contour models + customizations
    useGetProxied(
        { pathParams: { rest: 'contouring/list-active-models' } },
        { enabled: contourEnabled }
    );
    useGetProxied(
        { pathParams: { rest: 'config/contouring' } },
        { enabled: contourEnabled }
    );

    // Dose models
    useGetProxied(
        { pathParams: { rest: 'dose/list-active-models' } },
        { enabled: doseEnabled }
    );

    // Image translation models + customizations
    useGetProxied(
        { pathParams: { rest: 'translation/list-active-models' } },
        { enabled: imageEnabled }
    );
    useGetProxied(
        { pathParams: { rest: 'config/translation' } },
        { enabled: imageEnabled }
    );

    // Adapt (contour propagation) models
    useGetProxied(
        { pathParams: { rest: 'reg/list-active-models' } },
        { enabled: adaptEnabled }
    );
}
